import { Box, Typography } from "@mui/material";

export const LegendChip = ({
	color,
	label,
	value,
	valueColor,
}: {
	color: string;
	label: string;
	value: string;
	valueColor?: string;
}) => (
	<Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
		<Box
			sx={{
				width: 8,
				height: 8,
				bgcolor: color,
				borderRadius: "50%",
				flexShrink: 0,
			}}
		/>
		<Typography
			variant="caption"
			sx={{ fontSize: "0.7rem", color: "#555", lineHeight: 1 }}
		>
			{label}:{" "}
			<Box
				component="span"
				sx={{ fontWeight: 600, color: valueColor ?? "#1a1a1a" }}
			>
				{value}
			</Box>
		</Typography>
	</Box>
);
